document.addEventListener("DOMContentLoaded", function () {
  
  const anchorItems = document.querySelectorAll(".product-photo-thumb");
  anchorItems.forEach(function (item) {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      const imageId = this.getAttribute("data-image-id");
      const allImageWrappers = document.querySelectorAll(".fet_img_ctm");
      allImageWrappers.forEach(function (wrapper) {
        const wrapperId = wrapper.getAttribute("data-image-id");
        if (wrapperId === imageId) {
          wrapper.classList.remove("hide");
        } else {
          wrapper.classList.add("hide");
        }
      });
    });
  });
});

// ================================================

//  display variant based on the select thumbnail image

$(document).ready(function () {
  var thumbnails = $(".product-photo-thumb");
  var variantSelect = $("#productSelect");
  var selcted_variant_id = $('.product_variant_id').val();

  thumbnails.on("click", function (event) {
    event.preventDefault();
    var variantId = $(this).attr("data-variant-id");
    if (variantId) {
      updateVariantSelection(variantId);
    } else {
      console.log("No variant associated with this image.");
    }
  });

  function updateVariantSelection(variantId) {
    variantSelect.val(variantId).change();
  }

  updateVariantSelection(selcted_variant_id);
});
